import React from 'react';

import Nav from 'component/navigation/topbar';
import {LandingFooter} from 'component/footer';
import SEOComponent from 'component/reuse/seo';


export default function LandingLayout(props) {
  const context = props.context || {};

  return (
    <div id={props.id} className="page-wrapper">

      <SEOComponent seo={context.seo}/>

      <Nav />

      <div className="landing-content mt-5 text-black-2">
        {props.children}
      </div>

      <LandingFooter />
    </div>
  );
}
